// Brand-specific upsell component extended from
// common upsell component with global functionality
export default (commonUpsell) =>
  ({
    offerPath,
    paymentsPath,
    paymentsFailPath,
    paymentsSuccessPath,
  } = {}) => ({

  // Init common upsell functionality

  ...commonUpsell({
    upsellOfferType: "workouts",
    offerPath,
    paymentsPath,
    paymentsFailPath,
    paymentsSuccessPath,
  }),
  
  // Add or overwrite brand-specific functionality

})
